import { useQuery } from '@tanstack/react-query';
import client from '../api/client';

// The caller's own tag list (owner-scoped server-side). Shared by My Clients and Users.
export default function useClientTags() {
  const { data: tags = [], refetch } = useQuery({
    queryKey: ['client-tags'],
    queryFn: () => client.get('/client-tags').then(r => r.data),
    staleTime: 30000,
  });
  return { tags, refetch };
}
